export default __webpack_public_path__ + "static/media/NAKAD-LOGO-dark.855ec553.png";